export const AddCommas = (num: number): string => {
const [integerPart, decimalPart = ''] = num.toString().split('.');
const integerWithCommas = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return decimalPart ? `${integerWithCommas}.${decimalPart}` : integerWithCommas;
};